<template>
  <div class="unknown">
        <el-form ref="form" label-width="96px" :model="form">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="分公司" prop="branchCompanyId">
                        <el-select v-model="form.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
                            <el-option
                                v-for="item in listBranch"
                                :key="item.id"
                                :label="item.companyFullName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>    
                </el-col>
                <el-col :span="6">
                <el-form-item label="子公司" prop="companyId">
                    <el-select v-model="form.companyId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in listSon"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        @change="startTime"
                        v-model="form.startTimeString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        @change="endTime"
                        v-model="form.endTimeString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex">
            <el-col :span="6">
            <el-form-item label="处理状态" prop="resultStatus">
                <el-select v-model="form.resultStatus" placeholder="请选择">
                <el-option
                    v-for="item in listExamine2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
                </el-select>
            </el-form-item>
            </el-col>

            <el-col :span="6">
            <el-form-item label="时间类型筛选" prop="orderType">
            <el-radio-group v-model="form.orderType">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">报错时间</el-radio>
                <el-radio :label="2">处理时间</el-radio>
            </el-radio-group>
            </el-form-item>
            </el-col>
            
            <el-col :span="12">
            <el-form-item prop="searchInput" style="flex: 1;">
                <el-input
                    v-model.trim="form.searchString"
                    placeholder="订单号、订单ID、国内运单、国内单号、采购单号"
                    style="width: 70%;"
                ></el-input>
                <el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
            </el-col>
            </el-row>
            </el-form>

              <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :header-cell-style="{ textAlign: 'center' }"
                    v-loading="loadingTable"
                >
                    <el-table-column label="采购单号/国内单号" width="220">
                        <template slot-scope="scope">
                            <p>采购单号：{{scope.row.purchaseNumber}}</p>
                            <p>国内单号：{{scope.row.internalConveyNumber}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderId" label="订单号" width="240">
                        <template slot-scope="scope">
                            <div v-if="scope.row.purchaseFrom !== 2">
                                <div>订单号：{{ scope.row.amazonOrderId }}</div>
                                <div>订单ID：{{ scope.row.orderId }}</div>
                            </div>
                            <div v-else>
                                <div>库存编号：{{ scope.row.inventoryNo }}</div>
                            </div>
                            <el-row style="display: flex;align-items: center;">
                                <el-popover placement="top-start" title="物流内部备注" width="650" trigger="hover">
                                <el-table :data="RemarkList" style="width: 100%">
                                    <el-table-column prop="roleName" label="添加人" width="120" align="center"></el-table-column>
                                    <el-table-column prop="remarkContent" label="内容" width="330" align="center"></el-table-column>
                                    <el-table-column prop="createTime" label="时间" width="200" align="center"></el-table-column>
                                </el-table>
                                <i class="el-icon-s-order" style="font-size:18px;" slot="reference" @mouseover="orderIdchange(scope.row)"></i>
                                </el-popover>
                                <el-tag v-if="scope.row.outInterceptStatus === 1" type="danger" effect="dark" size="mini">拦截</el-tag>
                                <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="scope.row.isFreeze === 1">
                                    <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
                                </el-tooltip>
                            </el-row>
                            

                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="异常信息" align="left" width="300px">
                      <template slot-scope="scope">
                        <el-row type="flex">
                        <div v-if="scope.row.exceptionImages!==null&&scope.row.exceptionImages!==[]">
                          <el-popover trigger="hover" placement="right">
                            <img :src="scope.row.exceptionImages[0]" alt  style="width:500px;height:500px;"/>
                            <div class="scope_img" slot="reference">
                              <img :src="scope.row.exceptionImages[0]" alt style="width:50px;height:50px;margin-left:10px;"/>
                            </div>
                          </el-popover>
                        </div>
                          <div style="margin-left:10px;">
                            <p>{{ scope.row.exceptionRemark }}</p>
                          </div>
                        </el-row>
                      </template>
                    </el-table-column>
                    <el-table-column prop="handleDescription" label="处理方案" width="140" align="center"></el-table-column>
                    <el-table-column prop="exceptionResult" label="状态" width="140" align="center">
                        <template slot-scope="scope">
                            <div style="color:green;" v-if="scope.row.exceptionResult === 2">确认退件</div>
                            <div style="color:green;" v-if="scope.row.exceptionResult === 4">确认转库存</div>
                            <div style="color:green;" v-if="scope.row.exceptionResult === 6">确认取消异常</div>
                            <div style="color:green;" v-if="scope.row.exceptionResult === 10">确认转未知</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="核对结果" align="center" width="100">
                        <template slot-scope="scope">
                            <div style="color: #0565b7;" v-if="scope.row.checkResult === 0">未核对</div>
                            <div style="color: green;" v-else-if="scope.row.checkResult === 1">核对正确</div>
                            <div style="color: red;" v-else-if="scope.row.checkResult === 2">核对错误</div>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="errorTime" label="报错时间" width="110" sortable align="center"></el-table-column>
                    <el-table-column prop="handleTime" label="处理时间" width="110" sortable align="center"></el-table-column>
                    <!-- <el-table-column prop="updateTime" label="更新时间" width="200" sortable align="center"></el-table-column> -->
                    <el-table-column prop="putStorageTime" label="入库时间" width="110" sortable align="center"></el-table-column>
                    <el-table-column  label="尺寸/重量" width="150">
                        <template slot-scope="scope">
                            <p>尺寸：{{scope.row.purchaseSize}}</p>
                            <p>重量：{{scope.row.purchaseWeight}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="货物类型/货物等级" width="180" align="center">
                        <template slot-scope="scope">
                            <p>货物类型：{{scope.row.purchaseTypeCode}}</p>
                            <p>货物等级：{{scope.row.purchaseClass}}</p>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="purchaseClass" label="货物等级" align="center"></el-table-column> -->
                    <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
                    <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
                    <el-table-column width="200" prop="ziName" label="所属公司" align="center">
                        <template slot-scope="scope">
                            <div>
                                <span>{{ scope.row.branchCompanyName }}</span>
                                <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
                                <span>{{ scope.row.subCompanyName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="80" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="edit(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-dialog title="信息核对" :visible.sync="dialogVisible" width="60%">
                    <div class="box-card" v-if="Object.keys(infoData).length">
                        <template v-if="infoData.productInfos.length">
                            <el-row class="custom-container" v-for="item in infoData.productInfos" :key="item.id">
                                <el-col :span="4">
                                    <el-image
                                        style="width: 100%; height: 100%;"
                                        :src="item.imageUrl"
                                        :preview-src-list="item.imageUrl.split(',')"
                                    ></el-image>
                                </el-col>
                                <el-col :span="18" :offset="2">
                                    <div class="inform flex">
                                        <div class="title">亚马逊订单号：</div>
                                        <div>{{ infoData.amazonOrderId }}</div>
                                    </div>
                                    <div class="inform flex">
                                        <div class="title">标题：</div>
                                        <div>{{ item.title }}</div>
                                    </div>
                                    <div class="inform flex">
                                        <div class="title">SKU：</div>
                                        <div>{{ item.sku }}</div>
                                    </div>

                                    <el-row type="flex" justify="space-between">
                                        <div class="inform flex">
                                            <div class="title">数量：</div>
                                            <div>{{ item.quantityOrdered }}</div>
                                        </div>
                                        <!-- <el-button type="text">打印（0）</el-button> -->
                                    </el-row>
                                    <el-row type="flex" style="align-items: center;">
                                        <el-tag v-if="infoData.outInterceptStatus === 1" type="danger" effect="dark" style="font-size: 18px;">拦截</el-tag>
                                        <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="infoData.isFreeze === 1">
                                            <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
                                        </el-tooltip>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </template>
                        <div class="custom-container">
                            <div style="width:100%;">
                                <el-divider></el-divider>
                                <div style="display:flex;">
                                <div style="width:60%;">
                                    <el-row>
                                        <el-col :span="12">
                                            <div class="inform">采购单据号：{{ infoData.purchaseNumber }}</div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="inform">运单号：{{ infoData.internalConveyNumber }}</div>
                                        </el-col>
                                    </el-row>
                                    <div class="inform" v-if="infoData.insertFrom == 0" style="font-weight: bold;font-size: 18px;color: red;">海逊仓库核对详情：{{infoData.purchaseModel}}</div>
                                    <div class="inform" v-if="infoData.insertFrom !== 0" style="font-weight: bold;font-size: 18px;color: blue;">海逊仓库核对详情：{{infoData.purchaseModel}}</div>
                                    <el-row>
                                        <el-col :span="12">
                                            <div class="inform">入库尺寸：{{ infoData.purchaseSize }}</div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="inform">入库重量：{{ infoData.purchaseWeight }}</div>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <div class="inform">材积重：{{ infoData.purchaseSize }}</div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="inform">计费重：{{ infoData.purchaseWeight }}</div>
                                        </el-col>
                                    </el-row>
                                    <div class="inform">货物等级：{{ infoData.purchaseClass }}</div>
                                    <div class="inform">
                                        <h4>异常信息：</h4>
                                        <div style="padding:0 10px;">
                                            <template v-for="item in infoData.exceptionImages">
                                                <el-image
                                                    :key="item"
                                                    style="width: 100px; height: 100px"
                                                    :src="item"
                                                    fit="fit"
                                                    :preview-src-list="infoData.exceptionImages"
                                                ></el-image>
                                                <!-- <el-image :key="item" :src="item"></el-image> -->
                                            </template>
                                            <div class="inform" style="color: red;">{{ infoData.exceptionRemark }}</div>
                                        </div>
                                    </div>
                                    <el-row type="flex" align="middle" style="margin: 10px 0;">
                                    <h4>处理方案：</h4>
                                    <div>{{ infoData.handleDescription }}</div>
                                    </el-row>
                                    </div>
                                    <div style="width:40%;">
                                        <img :src="pics" alt="" v-if="infoData.invalidStatus === 0" style="width:200px;">
                                    </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    data() {
      return {
        str:"",
        form:{
            startTimeString:"",
            endTimeString:"",
            branchCompanyId:"",
            companyId:"",
            searchString:"",
            resultStatus: '',
            orderType:0
        },
        options:[],
        tableData:[],
        RemarkList:[],
        infoData:"",
        dialogVisible:false,

        currentPage: 1,
        pagesize: 50,
        size: 50,
        total: 0,

        listExamine2: [
          { value: 2, label: '确认退件' },
          { value: 4, label: '确认转库存' },
          { value: 6, label: '确认取消异常' },
          { value: 10, label: '确认转未知' },
        ],
        loadingTable: false,
        listBranch:[],
        listSon:[],

      }
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
        this.selectList()
        this.getBranchCompanyList()
    },
    methods: {
        search(){
            var obj = {
                companyId:this.str.company_id,
                startTimeString: this.form.startTimeString,
                endTimeString: this.form.endTimeString,
                searchString: this.form.searchString,
                exceptionResult: this.form.resultStatus,
                branchCompanyId:this.form.branchCompanyId,
                subCompanyId:this.form.companyId,
                orderType:this.form.orderType,
                page:this.currentPage,
                size:this.size,
                listType:5
            };
            this.loadingTable = true
            ajaxPost(Baseurl + "logisticsController/getServicePurchaseList", obj).then(res => {
                this.loadingTable = false
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listBranch = data;
                }
            });
        },
        selectChange(val){
            var obj = {
                id:val
            }
            ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById", obj).then(res => {
                this.listSon = res.data.data
                this.form.companyId = ""
            });
        },
        selectList(){
            ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
                this.options = res.data.data;
                // console.log(res.data)
            });
        },
        searchForm() {
          this.currentPage = 1
          this.search()
        },
        reset(){
            this.currentPage = 1
            this.form.branchCompanyId = ""
            this.form.companyId = ""
            this.form.startTimeString = ""
            this.form.endTimeString = ""
            this.form.searchString = ""
            this.form.resultStatus = ""
            this.form.orderType = 0
            this.listSon = []
            this.search()
        },
        edit(val){
            this.dialogVisible = true
            const API = Baseurl + 'logisticsController/getServicePurchaseDetails'
            const paramsData = {
                id: val.id
            }
            ajaxPost(API, paramsData).then(res => {
                if (res.data.code === 200) {
                    this.infoData = res.data.data;
                } else {
                    this.$message.error(res.data.data)
                }
            })
        },
        startTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.form.startTimeString = datetime;
        },
        endTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.form.endTimeString = datetime;
        },
        handleSizeChange(val){
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
        },
        orderIdchange(val){
            const API = Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
            const paramsData = {
                orderId: val.orderId
            }
            ajaxPost(API, paramsData).then(res => {
                if (res.data.code === 200) {
                this.RemarkList = res.data.data
                } else {
                this.$message.error(res.data.data)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

.unknown{
    margin-top: 30px;
    margin-bottom:50px;
}
.box{
    display: flex;
    justify-content: left;
}
.page {
    position: fixed;
    width: 80%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>
<style lang="scss" scoped>
/deep/{
    .details .el-form-item{
        margin-bottom: 0px!important;
    }
    
}
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.right-btn-container {
    display: flex;
    justify-content: flex-end;
}
.el-popover {
    position: absolute;
    background: #fff;
    min-width: 200px;
    border: 1px solid #ebeef5;
    padding: 12px;
    left: 40%;
    right: 0%;
    top: -17%;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: none;
    z-index: 9998;
    img {
        width: 90%;
    }
}
.padding0 {
    padding: 0;
}
</style>